import { render, staticRenderFns } from "./user-coupon.vue?vue&type=template&id=e53f814e&scoped=true&"
import script from "./user-coupon.vue?vue&type=script&lang=js&"
export * from "./user-coupon.vue?vue&type=script&lang=js&"
import style0 from "./user-coupon.vue?vue&type=style&index=0&id=e53f814e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f814e",
  null
  
)

export default component.exports